import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Send, Phone, Mail, CheckCircle } from "lucide-react";
import { motion } from "framer-motion";
import { useToast } from "@/components/ui/use-toast";

export default function ContactSection() {
  const { toast } = useToast();
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    website: "",
    hostingType: "",
    referral: "",
    comments: "",
  });

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    toast({
      title: "Message sent!",
      description:
        "Thank you for reaching out. We'll get back to you shortly.",
    });
  };

  if (submitted) {
    return (
      <section id="contact" className="py-20 sm:py-28">
        <div className="max-w-xl mx-auto px-4 text-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
          >
            <div className="w-16 h-16 rounded-full bg-accent/10 flex items-center justify-center mx-auto mb-6">
              <CheckCircle className="w-8 h-8 text-accent" />
            </div>
            <h2 className="text-3xl font-bold mb-4">Thank you!</h2>
            <p className="text-muted-foreground text-lg">
              We've received your message and will get back to you shortly.
            </p>
          </motion.div>
        </div>
      </section>
    );
  }

  return (
    <section id="contact" className="py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="max-w-2xl"
        >
          <p className="text-sm font-semibold uppercase tracking-widest text-primary mb-3">
            Contact
          </p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight mb-6">
            Let's get started
          </h2>
          <p className="text-muted-foreground text-lg leading-relaxed mb-8">
            Have some questions? Not sure what you really need?<br/>Contact us to start the conversation!
          </p>

          <div className="space-y-4 mb-10">
            <a
              href="tel:360.389.2897"
              className="flex items-center gap-4 p-4 rounded-xl bg-muted/40 border border-border/30 hover:border-primary/15 transition-all group"
            >
              <div className="w-10 h-10 rounded-xl bg-primary/[0.08] flex items-center justify-center">
                <Phone className="w-5 h-5 text-primary" />
              </div>
              <div>
                <p className="text-sm text-muted-foreground">
                  Call or Text
                </p>
                <p className="font-semibold group-hover:text-primary transition-colors">
                  360.389.2897
                </p>
              </div>
            </a>
            <a
              href="mailto:doug@host1help1.com"
              className="flex items-center gap-4 p-4 rounded-xl bg-muted/40 border border-border/30 hover:border-primary/15 transition-all group"
            >
              <div className="w-10 h-10 rounded-xl bg-primary/[0.08] flex items-center justify-center">
                <Mail className="w-5 h-5 text-primary" />
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Email</p>
                <p className="font-semibold group-hover:text-primary transition-colors">
                  doug@host1help1.com
                </p>
              </div>
            </a>
          </div>

          
        </motion.div>
      </div>
    </section>
  );
}